// extracted by mini-css-extract-plugin
export var orderSummary = "_q5-0";
export var showMoreLessButton = "_q5-1";